import React from 'react'

import Padding from 'components/Editor/Toolbar/Padding'
import { LayoutScroll } from 'components/LayoutPage'
import { BrandRichTextFontForms, BrandRichTextTypography } from 'services/Branding/components'
import { useElementFontCss, useElementFontValues } from 'services/Branding/hooks'
import { BrandFormEnum } from 'services/Branding/types'

import type { RichTextFormBrandType, RichTextBrandForms } from './richTextTypes'

const RichTextTypography: RichTextFormBrandType = ({ element, edited, device, setForm }) => {
  const { font } = element || {}
  const values = useElementFontValues('richText', device, font)
  const styles = useElementFontCss('richText', device, font)

  return (
    <LayoutScroll sizeAutoCapable>
      <Padding bottomSpace gap sides>
        <BrandRichTextTypography
          edited={edited.font}
          setActiveFont={setForm}
          styles={styles}
          values={values}
        />
      </Padding>
    </LayoutScroll>
  )
}

const FONTS_FORM_MAP: RichTextBrandForms = {
  [BrandFormEnum.STYLE]: RichTextTypography,
  [BrandFormEnum.TYPOGRAPHY]: RichTextTypography,
  ...BrandRichTextFontForms,
}

export default FONTS_FORM_MAP
